import { useState, useEffect } from "react";

const PHRASES_BY_MODE = {
  PASTORAL_CARE:        ["Reflexionando sobre el seguimiento…", "Considerando el contexto pastoral…", "Preparando orientación pastoral…"],
  ADMIN_REVIEW:         ["Analizando el contexto administrativo…", "Revisando información del sistema…", "Preparando respuesta…"],
  DISTRICT_OVERSIGHT:   ["Considerando el panorama del distrito…", "Revisando señales distritales…", "Preparando perspectiva…"],
  FOLLOW_UP:            ["Revisando historial de seguimiento…", "Considerando el próximo paso…", "Preparando orientación…"],
  MESSAGE_PREPARATION:  ["Reflexionando en el texto bíblico…", "Considerando el contexto de la congregación…", "Preparando contenido homilético…"],
  ANALYTICS_REVIEW:     ["Procesando datos del distrito…", "Analizando tendencias pastorales…", "Preparando resumen…"],
  default:              ["Reflexionando…", "Consultando contexto…", "Preparando respuesta…"],
};

/**
 * Rotates through contemplative thinking phrases while Kevia is loading.
 * Adapts phrasing to the current operational mode.
 * Resets to first phrase when not active.
 *
 * @param {boolean} isActive — true while loading/thinking
 * @param {string|null} [operationalMode] — from getOperationalMode()
 * @returns {string}
 */
export function useThinkingPhrase(isActive, operationalMode = null) {
  const [idx, setIdx] = useState(0);

  const phrases = PHRASES_BY_MODE[operationalMode] ?? PHRASES_BY_MODE.default;

  useEffect(() => {
    setIdx(0);
    if (!isActive) return;
    // Rotate every 2.4s — slow enough to feel contemplative, not anxious
    const timer = setInterval(() => {
      setIdx((prev) => (prev + 1) % phrases.length);
    }, 2400);
    return () => clearInterval(timer);
  }, [isActive, phrases.length]);

  return phrases[idx % phrases.length];
}
